import PubSub from 'underpub-js';
import gsap from 'gsap';

var MenuItemWithSubmenu = function (options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'el-MenuItemWithSubmenu',
    isOpen: false,
  };

  $.extend(true, this.options, options);
};

MenuItemWithSubmenu.prototype.init = function () {
  var self = this;

  self.$button = self.options.$el.children(`.${self.data.baseClass}__button`).eq(0);
  self.$buttonIcon = self.$button.find(
    `.${self.data.baseClass}__button__icon`,
  );
  self.$subnav = self.options.$el.children(`.${self.data.baseClass}__subnav`).eq(0);
  self.$subnavInner = self.$subnav.find(
    `.${self.data.baseClass}__subnav__inner`,
  );

  self.$subnav.length && self.initSubnavToggle();
};

MenuItemWithSubmenu.prototype.initSubnavToggle = function () {
  const self = this;

  const subnavInnerHeight = self.$subnavInner.outerHeight(true);

  let subnavIsShown = false;

  const subnavTL = gsap
    .timeline({
      paused: true,
      onStart: () => (subnavIsShown = true),
      onReverseComplete: () => (subnavIsShown = false),
    })
    .set(self.$subnavInner, {
      opacity: 0
    })
    .to(self.$buttonIcon, {
      rotate: 90,
      duration: 0.3,
      ease: 'expo.easeout',
    })
    .to(
      self.$subnav, {
        height: 'auto',
        ease: 'expo.easeout',
        duration: 0.5,
      },
      '<',
    )
    .fromTo(
      self.$subnavInner, {
        opacity: 0,
      }, {
        opacity: 1,
        duration: 0.25,
        ease: 'expo.easeout',
      },
      '-=.3',
    );

  const closeSubnav = () => {
    subnavIsShown && subnavTL.timeScale(1.5).reverse();

    if (self.options.$el.find(`.${self.data.baseClass}`).length) {
      self.options.$el.find(`.${self.data.baseClass}__button__icon`).not(self.$buttonIcon).trigger('closeSubnav');
    }
  };
  const openSubnav = () => !subnavIsShown && subnavTL.timeScale(1).play();

  const toggleSubnav = () => {
    subnavIsShown ? closeSubnav() : openSubnav();
  };

  self.$buttonIcon.on('closeSubnav', closeSubnav)
  self.$buttonIcon.on('click', toggleSubnav);
  PubSub.subscribe('resizeWidth', closeSubnav);
  PubSub.subscribe('closeMobileNav', closeSubnav);
};

export default MenuItemWithSubmenu;